export default {
  'not-found': 'Seite nicht gefunden',
  'internal-error': 'Anfrage kann nicht verarbeitet werden',
  'preview-error':
    '<strong>Der Artikel-Slug ist ungültig.</strong><br/> Bitte prüfen Sie, dass das Feld „Slug“ ausgefüllt wurde und dass der Artikel <strong>veröffentlicht</strong> oder <strong>als Entwurf gespeichert</strong> wurde.',
  continue: 'Jetzt weiterlesen',
}
